import React from 'react';
import { useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

import TranslationHelper from '../../../../../helpers/TranslationHelper';
import { RouteTankEditPage } from '@/app/pages/paths';
import { useStyles } from '../Themable.hooks';

interface IOwnProps {
    onClose: () => void;
    tankId: number;
}

const SendRFIDCardsWarning = ({ onClose, tankId }: IOwnProps) => {
    const classes = useStyles();
    const history = useHistory();

    const handleSetTerminalNumberClick = () => {
        onClose();
        const returnUrl = encodeURIComponent(
            history.location.pathname + history.location.search
        );
        history.push(
            `${RouteTankEditPage.replace(
                ':id',
                String(tankId)
            )}?returnUrl=${returnUrl}#advanced`
        );
    };

    return (
        <div className={classes.warningContainer}>
            <div className={classes.warningIconBadge}>
                <WarningAmberRoundedIcon className={classes.warningIcon} />
            </div>
            <Typography variant="h6" className={classes.warningTitle}>
                {TranslationHelper.translate('Warning')}
            </Typography>
            <Typography variant="body2" className={classes.warningMessage}>
                {TranslationHelper.translate(
                    'Enter the terminal number to enable RFID cards synchronization with the terminal.'
                )}
            </Typography>
            <Button
                variant="contained"
                color="primary"
                className={classes.warningButton}
                onClick={handleSetTerminalNumberClick}
            >
                {TranslationHelper.translate('Set terminal number')}
            </Button>
        </div>
    );
};

export default SendRFIDCardsWarning;
